import React from 'react';
import { marked } from "marked";

class TypingMarkdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayedText: '',
            currentIndex: 0,
            fullText: props.text || ''
        };
    }

    componentDidMount() {
        this.startTyping();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.fullText !== prevState.fullText) {
            this.startTyping();
        }
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    startTyping = () => {
        const { speed = 20, onTypingEnd, chunkSize = 1 } = this.props;
        const { currentIndex, fullText } = this.state;

        if (currentIndex < fullText.length) {
            this.timeoutId = setTimeout(() => {
                this.setState(
                    (prevState) => {
                        const endIndex = Math.min(
                            prevState.currentIndex + chunkSize,
                            fullText.length
                        );
                        const newText = prevState.displayedText +
                            fullText.substring(prevState.currentIndex, endIndex);
                        return {
                            displayedText: newText,
                            currentIndex: endIndex
                        };
                    },
                    () => this.startTyping()
                );
            }, speed);
        } else if (onTypingEnd) {
            onTypingEnd();
        }
    };

    render() {
        const { displayedText } = this.state;
        const parsedHtml = marked.parse(displayedText);
        const showCursor = false;

        return (
            <div className="typing-container">
                <span dangerouslySetInnerHTML={{ __html: parsedHtml }} />
                {showCursor && <span className="cursor" style={{
                    display: 'inline-block',
                    width: '2px',
                    height: '1em',
                    backgroundColor: '#000',
                    marginLeft: '2px',
                    animation: 'blink 0.7s infinite'
                }} />}
            </div>
        );
    }
}

export default TypingMarkdown;
